import React, { useState } from 'react'
import { supabase } from '../supabase'

export default function ResetPassword({ onRetourLogin }) {
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')

    if (password.length < 6) {
      setError('Le mot de passe doit contenir au moins 6 caractères.')
      return
    }
    if (password !== confirm) {
      setError('Les mots de passe ne correspondent pas.')
      return
    }

    setLoading(true)
    const { error: updateError } = await supabase.auth.updateUser({ password })
    setLoading(false)

    if (updateError) {
      setError(updateError.message)
    } else {
      setSuccess(true)
      setTimeout(() => {
        if (onRetourLogin) onRetourLogin()
      }, 3000)
    }
  }

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #f0fdf8 0%, #e8f7f2 100%)', padding: 20,
    }}>
      <div style={{
        background: 'white', borderRadius: 16, padding: '40px 36px',
        maxWidth: 400, width: '100%', boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ fontSize: 36, marginBottom: 8 }}>🔑</div>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: '#1a202c', margin: 0 }}>
            Nouveau mot de passe
          </h2>
          <p style={{ fontSize: 13, color: '#718096', marginTop: 6 }}>
            Choisissez un nouveau mot de passe pour votre compte.
          </p>
        </div>

        {success ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>✅</div>
            <div style={{ fontSize: 16, fontWeight: 700, color: '#1D9E75', marginBottom: 8 }}>
              Mot de passe mis à jour !
            </div>
            <div style={{ fontSize: 13, color: '#718096' }}>
              Redirection vers la connexion...
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#4a5568', marginBottom: 6 }}>
                Nouveau mot de passe
              </label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Au moins 6 caractères"
                required
                style={{
                  width: '100%', padding: '10px 12px', border: '1.5px solid #e2e8f0',
                  borderRadius: 8, fontSize: 14, outline: 'none', boxSizing: 'border-box',
                }}
                onFocus={e => e.target.style.borderColor = '#1D9E75'}
                onBlur={e => e.target.style.borderColor = '#e2e8f0'}
              />
            </div>

            <div style={{ marginBottom: 20 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#4a5568', marginBottom: 6 }}>
                Confirmer le mot de passe
              </label>
              <input
                type="password"
                value={confirm}
                onChange={e => setConfirm(e.target.value)}
                placeholder="Répétez le mot de passe"
                required
                style={{
                  width: '100%', padding: '10px 12px', border: '1.5px solid #e2e8f0',
                  borderRadius: 8, fontSize: 14, outline: 'none', boxSizing: 'border-box',
                }}
                onFocus={e => e.target.style.borderColor = '#1D9E75'}
                onBlur={e => e.target.style.borderColor = '#e2e8f0'}
              />
            </div>

            {error && (
              <div style={{
                fontSize: 13, color: '#e53e3e', background: '#fff5f5',
                border: '1px solid #fed7d7', borderRadius: 8, padding: '10px 12px', marginBottom: 16,
              }}>
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading || !password || !confirm}
              style={{
                width: '100%', padding: '12px 0', background: loading || !password || !confirm ? '#e2e8f0' : '#1D9E75',
                color: loading || !password || !confirm ? '#a0aec0' : 'white',
                border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600,
                cursor: loading || !password || !confirm ? 'default' : 'pointer',
              }}
            >
              {loading ? 'Mise à jour...' : 'Mettre à jour le mot de passe'}
            </button>

            {onRetourLogin && (
              <button
                type="button"
                onClick={onRetourLogin}
                style={{
                  width: '100%', marginTop: 10, padding: '10px 0',
                  background: 'none', border: 'none', color: '#718096',
                  fontSize: 13, cursor: 'pointer', textDecoration: 'underline',
                }}
              >
                Retour à la connexion
              </button>
            )}
          </form>
        )}
      </div>
    </div>
  )
}
